import React from 'react';
import AdminShell from './AdminShell';

export default function LoginHistory() {
  return (
    <AdminShell title="Login History">
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
          <h2 style={{ margin: 0, color: '#155c2b' }}>Login History</h2>
          <p style={{ color: '#555', marginTop: 12 }}>Track user sign-in events and login attempts from this panel.</p>
          <div style={{ marginTop: 24, color: '#777' }}>
            Login history content goes here.
          </div>
        </div>
      </div>
    </AdminShell>
  );
}
